import React from 'react';
import { cn } from '@/utils/common-helpers';
import Image from 'next/image';

export function FeaturesSectionHoverEffectsFlutterApp() {
    const features = [
        {
            title: 'Custom Flutter App Development',
            description:
                'We transform your app ideas into reality, crafting bespoke Flutter solutions that perfectly align with your vision and business objectives.',
            icon: '/img/technology/ic-development.svg',
        },
        {
            title: 'Flutter For Web Application',
            description:
                'Extend your reach beyond mobile with our expertise in building Progressive Web Apps (PWAs) and Single Page Applications (SPAs) using Flutter.',
            icon: '/img/technology/ic-web-application.svg',
        },
        {
            title: 'Android & iOS App Development',
            description: (
        <>
            Reach the widest possible audience with our native-like Flutter apps for both{' '}
            <a href="android-app-development" target="_self" className="font-semibold underline"
            >
                Android
            </a>{' '}
            and {' '}
            <a href="ios-app-development" target="_self" className="font-semibold underline"
            >
                iOS
            </a>{' '} platforms.
        </>
    ),
            icon: '/img/technology/ic-android-porting.svg',
        },
        {
            title: 'Flutter Migration & Upgradation',
            description:
                "Seamlessly migrate your existing app to Flutter or upgrade it to the latest version, ensuring optimal performance and compatibility.",
            icon: '/img/technology/ic-migration-upgradation.svg',
        },
        {
            title: 'Flutter UI/UX Strategy Development',
            description:
                'Our expert designers create intuitive and engaging user interfaces that enhance user experience and drive conversions',
            icon: '/img/technology/ic-ios-uiux.svg',
        },
        {
            title: 'Flutter Support & Maintenance',
            description:
                'We provide ongoing support and maintenance to keep your Flutter app running smoothly and up-to-date.',
            icon: '/img/technology/ic-support-maintenance.svg',
        },
    ];
    return (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3  relative z-10 max-w-7xl mx-auto">
            {features.map((feature, index) => (
                <Feature key={feature.title} {...feature} index={index} total={features.length} />
            ))}
        </div>
    );
}

const Feature = ({
    title,
    description,
    icon,
    index,
    total,
}: {
    title: string;
    description: React.ReactNode;
    icon: string;
    index: number;
    total: number;
}) => {
    return (
        <div
            className={cn(
                'flex flex-col py-[30px] relative group/feature dark:border-neutral-800',
                index % 3 === 0 && 'lg:border-l dark:border-neutral-800',
                (index + 1) % 3 !== 0 && 'lg:border-r dark:border-neutral-800',
                index >= 3 && 'lg:border-t dark:border-neutral-800 ',
                index === 5 && 'dark:border-neutral-800 ',
                index === 5 && total % 2 === 0 && 'mb-[-1.2px]',
            )}
        >
            {index < 3 && (
                <div className="opacity-0 group-hover/feature:opacity-100 transition duration-200 absolute inset-0 h-full w-full bg-gradient-to-t from-[#F5F6F9] dark:from-neutral-800 to-transparent pointer-events-none" />
            )}
            {index >= 3 && (
                <div className="opacity-0 group-hover/feature:opacity-100 transition duration-200 absolute inset-0 h-full w-full bg-gradient-to-b from-[#F5F6F9] dark:from-neutral-800 to-transparent pointer-events-none" />
            )}
            <div className="mb-[10px] relative z-10 px-10 text-neutral-600 dark:text-neutral-400">
                <Image src={icon} width={36} height={36} alt={title} title={title} className="" />
            </div>
            <div className="text-2xl font-bold mb-[10px] relative z-10 px-[30px]">
                <div className="absolute left-0 inset-y-0 h-6 group-hover/feature:h-8 w-1 rounded-tr-full rounded-br-full bg-neutral-300 dark:bg-neutral-700 group-hover/feature:bg-primary transition-all duration-200 origin-center" />
                <span className="group-hover/feature:translate-x-2 group-hover/feature:text-primary transition duration-200 inline-block text-neutral-800 dark:text-neutral-100">
                    {title}
                </span>
            </div>
            <p className="text-[#4C5773] mb-0 text-base text-neutral-600 dark:text-neutral-300 relative z-10 px-[30px]">
                {description}
            </p>
        </div>
    );
};
